import PropTypes from 'prop-types';
import React, { memo } from 'react';

/**
 * Error message under an invalid form field. Use inside a `.has-error` form group.
 *
 * @param {object} props Props.
 * @param {string} [props.message] Error message, nothing is rendered when it is empty.
 */
const FieldError = ({ message }) => (message ? <p className="help-block mb0">{message}</p> : null);

FieldError.propTypes = {
  message: PropTypes.string,
};

export default memo(FieldError);
